<template>
  <div>
    <span>{{scope.text}}</span>
  </div>
</template>

<script>
export default {
  name: 'Operation',
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  mounted() {}
}
</script>

<style>

</style>